import Heading from 'common/components/Heading';
import Text from 'common/components/Text';
import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import {
  PiMagnifyingGlass,
  PiSunHorizon,
  PiTrendUp,
} from 'react-icons/pi';
import Fade from 'react-reveal/Fade';
import MomentsArea, { MomentCard, MomentsGrid, SectionHeading } from './testimonials.style';

const momentIcons = {
  morning: PiSunHorizon,
  progress: PiTrendUp,
  search: PiMagnifyingGlass,
};

const Testimonial = (props) => {
  const data = useStaticQuery(graphql`
    query {
      appJson {
        testimonialData {
          slogan
          title
          desc
          moments {
            iconName
            id
            title
            text
          }
        }
      }
    }
  `);

  const moments = data?.appJson?.testimonialData;

  return (
    <div {...props}>
      <SectionHeading>
        <Text className="subtitle" content={moments?.slogan} />
        <Heading content={moments?.title} />
        <Text className="description" content={moments?.desc} />
      </SectionHeading>

      {moments?.moments?.length > 0 ? (
        <Fade up>
          <MomentsArea id="testimonials">
            <MomentsGrid>
              {moments.moments.map((moment) => (
                <MomentCard key={moment.id}>
                  <figure aria-hidden="true">
                    {React.createElement(
                      momentIcons[moment?.iconName] || PiSunHorizon,
                    )}
                  </figure>
                  <Heading as="h3" content={moment?.title} />
                  <Text content={moment?.text} />
                </MomentCard>
              ))}
            </MomentsGrid>
          </MomentsArea>
        </Fade>
      ) : (
        ''
      )}
    </div>
  );
};

export default Testimonial;
